<template>
  <el-container>
    <el-main style="padding: 0">
      <span>工单发料扫描</span>
      <el-divider/>
      <el-form ref="form" style="width: 100%" class="form" label-width="80px">
        <el-form-item label="发料单号">
          <el-input
              ref="billNoInput"
              v-model.trim="billNo"
              style="width: 300px"
              placeholder="请扫描发料单"
              @keyup.enter.native="scanHandle"/>
        </el-form-item>
        <el-form-item label="发料清单">
          <el-table
              v-loading="contentLoading"
              default-expand-all
              :data="bomList"
              row-key="pkid"
              border>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div style="margin-left: 47px; margin-right: 1px">
                  <el-table
                      empty-text="暂无库存"
                      class="sureReceiving"
                      :data="scope.row.stockDetailVOS"
                      style="border-right: 0"
                      row-key="pkid"
                      border>
                    <el-table-column align="center" label="#" type="index" width="50"/>
                    <el-table-column prop="code" align="left" label="库位编号" width="150"/>
                    <el-table-column prop="locationName" align="left" min-width="400" label="库位名称"/>
                    <el-table-column prop="unitName" align="center" width="80" label="单位"/>
                    <el-table-column prop="quantity" align="center" width="143" label="库存量"/>
                    <el-table-column align="center" prop="actualQuantity" label="实发数量" width="140">
                      <template slot-scope="scope1">
                        <el-form-item class="actualQuantity">
                          <el-input v-model="scope1.row.actualQuantity" placeholder="请输入数量" @input="validate(scope1.row.actualQuantity, scope1.row.quantity)"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="#" type="index" width="50"/>
            <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
            <el-table-column prop="materialName" align="left" min-width="400" label="物料名称"/>
            <el-table-column align="center" label="总需求量" width="143" prop="quantity">
              <template slot-scope="scope">
                <span style="color: #2d8cf0; font-weight: 700; font-size: 16px">{{scope.row.quantity}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="reset">重置</el-button>
          <el-button type="primary" :loading="sureLoading" @click="sureHandle">确认</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        billNo: "",
        bomList: [],
        sureLoading: false,
        contentLoading: false,
      };
    },

    mounted() {
      this.$refs.billNoInput.focus();
    },

    methods: {
      // 扫描发料单号 并验证发料单号是否存在
      scanHandle() {
        if (this.billNo) {
          this.$http.get("basic", `scanRecords/checkRepairOrder/${this.billNo}`).then((resp) => {
            if (resp.success) {
              this.getReceivingDetail();
            } else {
              this.billNo = "";
            }
          });
        }
      },
      // 获取发料清单信息
      getReceivingDetail() {
        this.contentLoading = true;
        this.$http.get("basic", `taskDispatchBills/barCode/${this.billNo}`).then((resp) => {
          if (resp.success) {
            this.bomList = resp.data.bomList;
          }
          this.contentLoading = false;
        });
      },
      // 输入实发数量时与库存量比较
      validate(value, quantity) {
        const isNum = /^\d+$/.test(+value);
        if (!isNum) {
          this.$confirm("请输入数字", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (+value > quantity) {
          this.$confirm("发料数量不能超过库存量", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
      },
      // 重置
      reset() {
        this.billNo = "";
        this.bomList = [];
      },
      // 确认
      sureHandle() {
        let result = true;
        if (!this.billNo) {
          this.$confirm("发料单号不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        if (this.bomList.length == 0) {
          this.$confirm("发料清单不能为空", "错误", {
            type: "error",
            showCancelButton: false,
          });
          return;
        }
        this.bomList.forEach((item) => {
          let sum = 0;
          item.stockDetailVOS.forEach((i) => {
            sum += Number(i.actualQuantity);
          });
          if (sum !== item.quantity) {
            this.$confirm("实发数量与总需求量不一致", "错误", {
              type: "error",
              showCancelButton: false,
            });
            result = false;
          }
          return result;
        });
        if (!result) {
          return false;
        }
        this.sureLoading = true;
        const params = {
          billNo: this.billNo,
          bomList: this.bomList,
        };
        this.$http
          .post("basic", `scanRecords/insertByTaskDispatchBill/${this.billNo}`, params)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("扫描成功");
              this.billNo = "";
              this.bomList = [];
              this.$refs.billNoInput.focus();
            }
            this.sureLoading = false;
          })
          .catch(() => {
            this.sureLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.sureReceiving .el-input--mini .el-input__inner {
  text-align: center;
}

.actualQuantity.el-form-item--mini.el-form-item {
  margin-bottom: 0;
}
</style>
